import * as React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../reducers/reducers';
import { selectCompletedWorkItems } from '../../selectors/memoizedSelectors';
import { selectRelease } from '../../selectors/selectors';
import { ReleaseComponentProps } from '../../typescriptHelpers';
import Drawer from 'antd/lib/drawer';
import Text from 'antd/lib/typography/Text';
import { CodeType, CommitItem, PRItem } from '../../types';

interface CompletedTasksComponentProps extends ReleaseComponentProps {
    open: boolean;
    onClose: () => void;
}

const CompletedTasksComponent: React.FC<CompletedTasksComponentProps> = (props: CompletedTasksComponentProps) => {
    const completedItems = useSelector((state: RootState) =>
        selectCompletedWorkItems(state, props.appId, props.releaseId),
    );
    const displayableVersion = useSelector(
        (state: RootState) => selectRelease(state, props.releaseId).displayableVersion,
    );

    return (
        <Drawer
            title={<Text>New in {displayableVersion}</Text>}
            placement="right"
            closable
            onClose={props.onClose}
            open={props.open}
            width={500}
        >
            {completedItems.length > 0 && (
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                    }}
                >
                    <Text>New work appearing in this release.</Text>
                    <ul style={{ padding: 0, margin: 0, paddingLeft: 16, paddingRight: 16, marginTop: 24 }}>
                        {completedItems.map((item, index) => {
                            let identifier = '';
                            let description = '';

                            if (item.ticket) {
                                identifier = item.ticket.identifier;
                                description = item.ticket.description;
                            } else if (item.code) {
                                identifier = item.code.identifier;

                                switch (item.code.type) {
                                    case CodeType.Commit:
                                        description = (item.code as CommitItem)?.message;
                                        break;
                                    case CodeType.PullRequest:
                                        description = (item.code as PRItem)?.title;
                                        break;
                                }
                            }

                            return (
                                <li key={index}>
                                    {identifier} - {description}
                                </li>
                            );
                        })}
                    </ul>
                </div>
            )}
            {completedItems.length === 0 && <Text type="secondary">No completed tasks found for this release.</Text>}
        </Drawer>
    );
};

export default CompletedTasksComponent;
